var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.meta.guest)?_vm._t("guest",function(){return [_c('router-view')]}):[_vm._t("default"),_vm._t("navigation-drawer-toggler-left"),_vm._t("navigation-drawer-toggler-right"),_vm._t("navigation-drawer-toggler-inner")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }